/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".captcha[_ngcontent-%COMP%]{background-repeat:no-repeat;height:35px;border:none;width:90px!important}.text-right[_ngcontent-%COMP%]{text-align:right}.form-control-feedback[_ngcontent-%COMP%]{position:unset}"];
export { styles as styles };
